import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

// Hardcoded configuration - Safe to be public for client-side Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDHL6hUPcC22hB7-cYUOBptTkSeMtwUKWs",
  authDomain: "tinysystems-55a5b.firebaseapp.com",
  projectId: "tinysystems-55a5b",
  storageBucket: "tinysystems-55a5b.firebasestorage.app",
  messagingSenderId: "124057518876",
  appId: "1:124057518876:web:53dd13dc938bccfe2570d9"
};

// Initialize Firebase directly
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { db, auth, googleProvider, signInWithPopup };